import React, { PureComponent } from 'react';

import AgGrid from '../../shared/agGrid/agGrid.component';
import { CustomRenderer } from '../../shared/numeralRenderers';

import SubledgerJournalsPropTypes from './subledgerJournals.propTypes';
import {
  alignLeftCellStyle,
  alignRightCellStyle,
} from '@common/cellStyles';
import { decodeCountryTaxType } from '../../utils/encodeDecodeCTT';
import DateCellRenderer from '../../shared/agGrid/cellRenderers/dateCellRenderer.component';

const baseColumnDefs = [
  { headerName: 'Reviewed Date', field: 'reviewedDate', minWidth: 125, cellRenderer: DateCellRenderer },
  { headerName: 'Tax Year', field: 'taxYear', minWidth: 80 },
  { headerName: 'Company Code', field: 'companyCode', minWidth: 120, ...alignLeftCellStyle },
  { headerName: 'Trading Partner', field: 'tradingPartner', minWidth: 120, ...alignLeftCellStyle },
  { headerName: 'Country Code', field: 'countryCode', minWidth: 80 },
  { headerName: 'Country Tax Type', field: 'countryTaxType', minWidth: 80 },
  { headerName: 'Subledger Account', field: 'slAccount', minWidth: 120, ...alignLeftCellStyle },
  { headerName: 'Book Type', field: 'bookType', minWidth: 50 },
  { headerName: 'Account', field: 'description', minWidth: 80, ...alignLeftCellStyle },
  { headerName: 'Currency', field: 'currencyCode', minWidth: 80 },
];

const customColumnDefs = [
  ...baseColumnDefs,
  { headerName: 'Debit Amount', field: 'debit', minWidth: 100, cellRenderer: CustomRenderer, ...alignRightCellStyle },
  { headerName: 'Credit Amount', field: 'credit', minWidth: 100, cellRenderer: CustomRenderer, ...alignRightCellStyle },
];

class TaxEntryDetails extends PureComponent {
  static propTypes = {
    subledgerJournals: SubledgerJournalsPropTypes,
  };

  render() {
    const { subledgerJournals } = this.props;

    const subledgerJournalsWithDecodedTaxTypes = subledgerJournals.map(subledgerJournal => {
      const { countryCode, countryTaxType } = decodeCountryTaxType(subledgerJournal.countryTaxType);

      return {
        ...subledgerJournal,
        countryCode,
        countryTaxType,
      };
    });

    return (
      <div className="ag-theme-bootstrap subledger-journals-tab">
        <AgGrid
          columnDefs={customColumnDefs}
          headerHeight={50}
          domLayout="autoHeight"
          rowData={subledgerJournalsWithDecodedTaxTypes}
        />
      </div>
    );
  }
}

export default TaxEntryDetails;
